export default __webpack_public_path__ + "static/media/pasodos.4ed5eff3.png";